'use client';

import React from 'react';
import styled from 'styled-components';

const VK_CLIENT_ID = process.env.NEXT_PUBLIC_VK_CLIENT_ID!;
const VK_CODE_VERIFIER = process.env.NEXT_PUBLIC_VK_CODE_VERIFIER!;

export const VKAuthRedirectButton: React.FC = () => {
  const generateState = (): string => {
    // Генерация случайного state длиной 32 символа (a-z, A-Z, 0-9, _, -)
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_-';
    let result = '';
    for (let i = 0; i < 32; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  const generateCodeChallenge = async (codeVerifier: string): Promise<string> => {
    // Преобразование code_verifier в code_challenge методом S256
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hash = await crypto.subtle.digest('SHA-256', data);

    // Кодирование в base64url (RFC 7636)
    return btoa(String.fromCharCode(...new Uint8Array(hash)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  };

  const handleLogin = async () => {
    try {
      const state = generateState();
      const codeChallenge = await generateCodeChallenge(VK_CODE_VERIFIER);
      const redirectUri = `https://auth.plande.ru/auth/vk`;

      const url = new URL('https://id.vk.ru/authorize');
      url.searchParams.append('response_type', 'code');
      url.searchParams.append('client_id', VK_CLIENT_ID);
      url.searchParams.append('redirect_uri', redirectUri);
      url.searchParams.append('state', state);
      url.searchParams.append('code_challenge', codeChallenge);
      url.searchParams.append('code_challenge_method', 'S256');
      url.searchParams.append('scope', 'email phone');

      // Дополнительные параметры (опционально)
      // url.searchParams.append('scope', 'email phone');
      // url.searchParams.append('prompt', 'login');
      // url.searchParams.append('lang_id', '0');
      // url.searchParams.append('scheme', 'light');

      window.location.href = url.toString();
    } catch (error) {
      console.error('Error during VK auth preparation:', error);
    }
  };

  return (
    <Button onClick={handleLogin}>
      <Icon
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 101 100"
        aria-hidden="true"
      >
          <g clipPath="url(#clip0_2_2)">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.52944 7.02944C0.5 14.0589 0.5 25.3726 0.5 48V52C0.5 74.6274 0.5 85.9411 7.52944 92.9706C14.5589 100 25.8726 100 48.5 100H52.5C75.1274 100 86.4411 100 93.4706 92.9706C100.5 85.9411 100.5 74.6274 100.5 52V48C100.5 25.3726 100.5 14.0589 93.4706 7.02944C86.4411 0 75.1274 0 52.5 0H48.5C25.8726 0 14.5589 0 7.52944 7.02944ZM17.3752 30.4169C17.9168 56.4169 30.9167 72.0418 53.7084 72.0418H55.0003V57.1668C63.3753 58.0001 69.7082 64.1252 72.2498 72.0418H84.0835C80.8335 60.2085 72.2914 53.6668 66.9581 51.1668C72.2914 48.0835 79.7915 40.5835 81.5831 30.4169H70.8328C68.4995 38.6669 61.5836 46.1668 55.0003 46.8751V30.4169H44.2499V59.2501C37.5833 57.5835 29.1668 49.5002 28.7918 30.4169H17.3752Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_2_2">
              <rect width="100" height="100" fill="white" transform="translate(0.5)"/>
            </clipPath>
          </defs>
      </Icon>
      Войти через VK
    </Button>
  );
};

/* ---------------- styled-components ---------------- */

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  border: none;
  border-radius: 56px;
  background-color: #0077FF;
  color: #fff;

  height: 56px;
  min-width: 280px;
  padding: 14px 24px 14px 18px;

  font-size: 18px;
  line-height: 20px;
  font-weight: 500;

  cursor: pointer;
  transition: background-color 0.3s, opacity 0.3s;

  &:hover {
    background-color: #005ECC;
  }

  &:active {
    opacity: 0.8;
  }
`;

const Icon = styled.svg`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export default VKAuthRedirectButton;
